import { createRoute, redirect } from '@tanstack/react-router';
import { Route as appRoute } from '../../../app.js';
import { useAuthStore } from '../../../../lib/auth.js';
import { canSeePrivateCourses } from '../../../../lib/capabilities.js';
import { AdminPageHeader } from '../../../../components/admin/AdminPageHeader.js';
import { CourseForm } from '../../../../components/admin/CourseForm.js';

export const Route = createRoute({
  getParentRoute: () => appRoute,
  path: 'admin/private-courses/new',
  beforeLoad: () => {
    if (!canSeePrivateCourses(useAuthStore.getState().user)) throw redirect({ to: '/app' });
  },
  component: NewPrivateCoursePage,
});

function NewPrivateCoursePage() {
  return (
    <div>
      <AdminPageHeader
        title="New private course"
        description="Add a course visible only to your agency. It appears in your consultants' catalogue alongside master courses."
        backTo="/app/admin/private-courses"
        backLabel="Private courses"
      />
      <CourseForm variant="private" />
    </div>
  );
}
